import { render } from "./EditCoverage.vue?vue&type=template&id=0dc738c7"
import script from "./EditCoverage.vue?vue&type=script&lang=js"
export * from "./EditCoverage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__